import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

import { useDispatch, useSelector } from "react-redux";
import { fetchVehiclesData } from "../../store/vehicles/actions";

const Vehicles = props => {
    const dispatch = useDispatch();

    const { data, loading, error } = useSelector(state => state.Vehicles);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectVehicleImages, setSelectedVehicleImages] = useState([]);

    const handleViewImages = (data) => {
      if(data.vehicle_media.length > 0){
        setSelectedVehicleImages(data || []);
        // setSelectedDocIds([]);
        setModalOpen(true);
      }
    };

    const isImage = (url) => {
      return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);
    };

    useEffect(() => {
        dispatch(fetchVehiclesData());
      }, [dispatch]);

    const columns = useMemo(
        () => [
          {
            header: "Image",
            accessorKey: "image",
            enableColumnFilter: false,
            cell: ({ row }) => (
              <img
                onClick={() => handleViewImages(row.original)}
                src={row.original.image || "assets/images/no-image.png"}
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />
            )
          },
          {
            header: 'Make Name',
            accessorKey: 'makeName',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Model Name',
            accessorKey: 'modelName',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Body Type',
            accessorKey: 'bodyType',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Vehicle Type',
            accessorKey: 'vehicleType',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'License Plate',
            accessorKey: 'licensePlate',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'In Service?',
            accessorKey: 'in_service',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Is Enable?',
            accessorKey: 'is_enable',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Driver',
            accessorKey: 'driver',
            enableColumnFilter: false,
            enableSorting: true,
          },
        ],
        []
      );

    const totalRecords = data?.data?.length ?? 0;
    
    const transformedData = useMemo(() => {
      return data?.data?.map(item => {
          return {
              ...item,
              image: item.vehicle_media?.[0]?.url,
              makeName: item.make_name || "N/A",
              modelName: item.model_name || "N/A",
              bodyType: item.body_type || "N/A",
              vehicleType: item.type_name || "N/A",
              licensePlate: item.license_plate || "N/A",
              in_service: item.in_service == 1 ? 'YES' : 'NO' || "N/A",
              is_enable: item.is_enable == 1 ? 'YES' : 'NO' || "N/A",
              driver: item.driver.name || "N/A",
          };
      });
    }, [data]);

    document.title = "Vehicles | Moeen";
    return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Vehicles" />
        {loading ? (
        <Skeleton count={10} height={40} />
        ) : (
        <TableContainer
          columns={columns}
          data={transformedData || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
          pagination="pagination"
          paginationWrapper='dataTables_paginate paging_simple_numbers'
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      )}

      {modalOpen && (
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Vehicle Images</h5>
                  <button type="button" className="btn-close" onClick={() => setModalOpen(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="d-flex flex-wrap gap-3">
                    {selectVehicleImages.vehicle_media.map(doc => {

                      return (
                        <div
                          key={doc.id}
                          className={`card p-2`}
                          style={{ width: "180px", position: "relative" }}
                        >
                          {
                            isImage(doc.url) ? (
                              <img
                                src={doc.url}
                                alt={selectVehicleImages.bodyType}
                                style={{ width: "100%", height: "100px", objectFit: "cover", borderRadius: "6px" }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  borderRadius: "6px",
                                  backgroundColor: "#f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "14px",
                                  color: "#333"
                                }}
                              >
                                {getFileExtension(doc.url).toUpperCase()} File
                              </div>
                            )
                          }
                          <div className="mt-2 text-center fw-semibold">{selectVehicleImages.bodyType} - {selectVehicleImages.makeName}</div>

                          {/* View Button */}
                          <button
                            className="btn btn-sm btn-outline-primary mt-2"
                            style={{ width: "100%" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(doc.url, '_blank');
                            }}
                          >
                            View
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Vehicles.propTypes = {
  t: PropTypes.any
};

export default Vehicles;